import { Dispatch, SetStateAction } from 'react';
import { ToastStateHandler, UserApi } from '../../../api';
import { PolicyDto } from '../../../commonTypes/user.types';
import { useContainer } from '../../useContainer';
import { OrganizationMembersWithBranchDataDto } from '../../../commonTypes/acs';
import { useTranslation } from '../../useTranslation';

const useHttpChangePolicyInitialAmount = (setData: Dispatch<SetStateAction<OrganizationMembersWithBranchDataDto[]>>) => {
    const { t } = useTranslation('newNotifications');
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);

    const exec = (userSub: string, leaveType: string, newInitialAmount: number) => {
        const { exec, clearCache, abort } = userApi.changePolicyInitialAmount({
            params: { userSub, leaveType },
            body: { newInitialAmount },
            onSuccess: res => {
                updatePolicy(userSub, res.body);
                toastHandler.push('success', t('policy.initialAmountChangeTitle'), t('policy.initialAmountChangeError'));
                clearCache();
            },
            onError: () => toastHandler.push(`error`, t('policy.initialAmountChangeTitle'), t('policy.initialAmountChangeError')),
        });
        exec();
        return abort;
    };

    const updatePolicy = (userSub: string, updatedPolicy: PolicyDto) => {
        setData(prevData => {
            const userToChange = prevData.find(user => user.userSub === userSub);
            if (!userToChange) return prevData;

            userToChange.policies = userToChange.policies.map(policy => {
                if (updatedPolicy.leaveType === policy.leaveType) return { ...policy, ...updatedPolicy };
                else return { ...policy };
            });

            return prevData.map(user => (user.userSub === userSub ? { ...userToChange } : { ...user }));
        });
    };

    return { exec };
};

export default useHttpChangePolicyInitialAmount;
